import {
  arrowRight,
  calendar,
  checkmark,
  chevronDownSmall,
  chevronUpSmall,
  cross,
  crossSmall,
  fallingBoxes,
  heart,
  home,
  information,
  informationCircle,
  list,
  lock,
  magnifyingGlass,
  mail,
  membershipCard,
  minus,
  minusSmall,
  note,
  pencil,
  person,
  phone,
  questionMark,
  questionMarkCircle,
  shoppingBag,
  speechBubble,
  warningTriangle
} from '@ingka/ssr-icon/icons';

export const SSRIcons = {
  person,
  warningTriangle,
  arrowRight,
  shoppingBag,
  calendar,
  speechBubble,
  checkmark,
  chevronDownSmall,
  chevronUpSmall,
  cross,
  crossSmall,
  mail,
  membershipCard,
  fallingBoxes,
  heart,
  questionMarkCircle,
  questionMark,
  home,
  information,
  informationCircle,
  list,
  note,
  phone,
  pencil,
  minus,
  minusSmall,
  magnifyingGlass,
  lock
};
